module.exports = __webpack_public_path__ + "img/68400.01cbd946.jpg";